/*@ngInject*/
const XMLUtil = function () {

    function convertBooleanValue(value) {
        if (value === 'false') {
            value = false;
        } else if (value === 'true') {
            value = true;
        }

        return value;
    }

    function flatten(object) {
        let check = _.isPlainObject(object) && _.size(object) === 1,
            obj = check ? _.values(object)[0] : object;

        if (_.isPlainObject(obj)) {
            return _.mapValues(obj, function (v) {
                return flatten(v);
            });
        }

        obj = convertBooleanValue(obj);
        return obj;
    }

    this.parseString = function (xmlString) {
        let obj = {};

        if (_.isEmpty(xmlString)) {
            return obj;
        }

        obj = new X2JS({
            attributePrefix: ''
        }).xml_str2json(xmlString);

        return flatten(obj);
    };

    this.parseStringWithoutFlattening = function (xmlString) {
        let obj = {};

        if (_.isEmpty(xmlString)) {
            return obj;
        }

        obj = new X2JS({
            attributePrefix: ''
        }).xml_str2json(xmlString);

        return obj;
    };

    this.toXmlString = function (obj) {
        let str = '';

        if (!_.isNil(obj)) {
            str = new X2JS().json2xml_str(JSON.parse(angular.toJson(obj)));
        }

        return str;
    };
};

angular.module('umCore')
    .service('xmlUtil', XMLUtil);
